export const commonPopup = {
  title: '',
  content: '',
  ok: 'OK',
  cancel: 'CANCEL',
};
